import last from 'lodash/last'
import moment from 'moment'

import { OffersListRequest } from '@/modules/api'
import ListingSearchDataParams from '@/modules/search/ListingSearchDataParams'

function toggleItemAvailability (item, query, value) {
  item.selected = value
  if (query == 'From' || query == 'Dest') item.enabled = value
}

export default {
  data () {
    return {
      listingSearchParams: new ListingSearchDataParams(OffersListRequest.getInitialUrl()).params,
    }
  },
  methods: {
    paramMatches (option, key, property) {
      const item = this.listingSearchParams.find(item => item.key === key)
      if (!item) return false

      const values = item.value.split(',')
      return values.find(value => value === option[property])
    },

    setSelectedForList (list, query, property) {
      if (!list) return
      list.forEach(el => {
        if (this.paramMatches(el, query, property)) toggleItemAvailability(el, query, true)
        else toggleItemAvailability(el, query, false)
      })
    },

    setSelectedForDurations (durations, query) {
      if (!durations) return
      
      const item = this.listingSearchParams.find(item => item.key === query)
      if (!item) durations.range = last(durations.ranges).value
      else durations.range = item.value
    },

    setSelectedForPrices (prices, queryFrom, queryTo, queryType) {
      const itemFrom = this.listingSearchParams.find(item => item.key === queryFrom)
      const itemTo = this.listingSearchParams.find(item => item.key === queryTo)
      const itemType = this.listingSearchParams.find(item => item.key === queryType)

      const priceFrom = itemFrom ? itemFrom.value : '0'
      const priceTo = itemTo ? itemTo.value : '0'
      const priceType = itemType ? itemType.value : 'man'

      prices.selected = `${priceFrom}:${priceTo}`
      prices.type = priceType
    },

    setSelectedForDates (dates, queryDeparture, queryReturn) {
      const itemDeparture = this.listingSearchParams.find(item => item.key === queryDeparture)
      const itemReturn = this.listingSearchParams.find(item => item.key === queryReturn)
      this.setSelectedDateStart(dates, itemDeparture)
      this.setSelectedDateEnd(dates, itemReturn)
    },

    setSelectedDateStart (dates, departureDate) {
      if (!departureDate) return

      dates.selected.start = moment(departureDate.value).isBefore(dates.validDates.start)
        ? dates.validDates.start
        : moment(departureDate.value)
    },

    setSelectedDateEnd (dates, returnDate) {
      if (!returnDate) return

      dates.selected.end = moment(returnDate.value).isAfter(dates.validDates.end)
        ? dates.validDates.end
        : moment(returnDate.value)
    },

    setAdults (adults, query, defaultValue) {
      const item = this.listingSearchParams.find(item => item.key === query)
      if (!item) adults.value = defaultValue
      else adults.value = parseInt(item.value)
    },

    setChildren (people, query, defaultValue) {
      /**
       * Because we have two different types of child filters we need to make sure
       * that 'Children' is not taken into filtered items - we need only these that starts with 'Child'
       */
      const items = this.listingSearchParams.filter(item => item.key.startsWith(query) && item.key != 'Children')
      if (!items.length) {
        people.children.value = defaultValue
        people.childrenBirthdays = []
      } else {
        people.children.value = items.length
        people.childrenBirthdays = items.map(item => moment(item.value))
      }
    },

    setAirportsFromListingParamsForWeb () {
      const airports = document.querySelector('.custom-select-airport select')
      if (airports) {
        airports.options.forEach(airport => {
          if (this.paramMatches(airport, 'From', 'value')) airport.selected = true
          else airport.selected = false
        })
      }
    },

    setDestinationsFromListingParamsForWeb () {
      const destinations = document.querySelector('.custom-select-country select')
      if (destinations) {
        destinations.options.forEach(destination => {
          if (this.paramMatches(destination, 'Dest', 'value')) destination.selected = true
          else destination.selected = false
        })
      }
    },

    updateNewSearchFilters () {
      const dates = this.isMobile ? { selected: this.selectedDates, validDates: this.validDates } : this.dates
      this.setSelectedForList(this.airports, 'From', 'id')
      this.setSelectedForList(this.destinations, 'Dest', 'id')
      this.setSelectedForList(this.hotelStandards, 'HotelStandard', 'id')
      this.setSelectedForList(this.attractions, 'Attractions', 'id')
      this.setSelectedForList(this.offerTypes, 'OfferType', 'id')
      this.setSelectedForList(this.beaches, 'Beach', 'id')
      this.setSelectedForList(this.sportsEntertainments, 'SportsEntertainment', 'id')
      this.setSelectedForList(this.forChildren, 'ForChildren', 'id')
      this.setSelectedForList(this.hotelCategories, 'HotelCategory', 'id')
      this.setSelectedForList(this.amenities, 'Amenities', 'id')
      this.setSelectedForList(this.boardStandards, 'BoardStandards', 'id')
      this.setSelectedForDurations(this.durations, 'DurationInterval')
      this.setSelectedForPrices(this.pricePerPerson, 'PriceFrom', 'PriceTo', 'PriceType')
      this.setSelectedForDates(dates, 'DateOfDeparture', 'DateOfReturn')
      this.setAdults(this.people.adults, 'Adults', 2)
      this.setChildren(this.people, 'Child', 0)

      this.updateAvailableValues()
    },

    updateSearchFilters () {
      this.setDestinationsFromListingParamsForWeb()
      this.setAirportsFromListingParamsForWeb()
    },
  },
}


// WEBPACK FOOTER //
// ./src/modules/search/ExternalDataAdapter.js